<app-card class="challenge-details-container" fullHeight="true">
  <app-title-section
    title="{{ 'challenges.challenges' | translate }}"
    backButton="true"
    [size]="3"
    [spacingBottom]="32"
    (handlePressBack)="goBack()"
  ></app-title-section>
  @if (isLoading()) {
  <app-spinner data-test-id="challenge-details-spinner"></app-spinner>
  } @else {
  <div class="challenge-details-heading">
    <app-img-card
      [imageUrl]="challenge().imageUrl"
      [title]="challenge().title"
      [subtitle]="subtitle()"
      [backgroundColor]="theme?.light?.colors?.[0]?.value ?? '#1100DB'"
      aspectRatio="192.52/115.64"
      [alignment]="HorizontalAlignment.RIGHT"
      data-test-id="challenge-details-img-card"
    ></app-img-card>
    <div class="challenge-details-title">
      <app-heading [titleLevel]="2" [headingLevel]="1" [spacingBottom]="8">
        {{ challenge().title }}
      </app-heading>
      <p>{{ subtitle() }}</p>
    </div>
    <app-button
      type="primary"
      (handleClick)="createChallenge()"
      data-test-id="challenge-details-create-challenge-button"
    >
      {{ 'challenges.createChallenge' | translate }}
    </app-button>
  </div>
  <div class="challenge-information-container">
    <app-heading [titleLevel]="2" [headingLevel]="2" [spacingBottom]="8">
      {{ 'challenges.challengeInformation' | translate }}
    </app-heading>
    <p>
      {{ challenge().description }}
    </p>
  </div>
  <div class="challenge-category-container">
    <app-heading [titleLevel]="2" [headingLevel]="2" [spacingBottom]="8">
      {{ 'challenges.workoutCategories' | translate }}
    </app-heading>
    <p>
      {{ categories() }}
    </p>
  </div>
  <div class="workout-schedule-container">
    <app-heading [titleLevel]="2" [headingLevel]="2" [spacingBottom]="16">
      {{ 'challenges.workoutSchedule' | translate }}
    </app-heading>
    <app-tabs data-test-id="challenge-details-tabs">
      <app-tabs-item
        *ngFor="let week of schedule().stages"
        [title]="week.title"
        data-test-id="challenge-details-tabs-item"
      >
        <div class="challenge-workout-list">
          <div
            *ngFor="let workout of week.workouts"
            class="challenge-workout-list-item"
            data-test-id="challenge-details-workout-list-item"
          >
            <div>
              <h4>
                {{ workout.cls.displayTypeName }} &#8226;
                {{ workout.cls.subtitle }}
              </h4>
              <h1>
                {{ workout.cls.name }}
              </h1>
            </div>
            <div class="challenge-workout-list-item-icons">
              <div class="item-icon">
                <div class="icon">
                  <svg
                    width="15"
                    height="13"
                    viewBox="0 0 15 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_11053_21558)">
                      <path
                        d="M9.00014 16.17L5.53014 12.7C5.14014 12.31 4.51014 12.31 4.12014 12.7C3.73014 13.09 3.73014 13.72 4.12014 14.11L8.30014 18.29C8.69014 18.68 9.32014 18.68 9.71014 18.29L20.2901 7.71C20.6801 7.32 20.6801 6.69 20.2901 6.3C19.9001 5.91 19.2701 5.91 18.8801 6.3L9.00014 16.17Z"
                        fill="#14E25A"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_11053_21558">
                        <rect width="15" height="13" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="metric">
                  {{ workout.duration }}
                </div>
              </div>
              <div class="item-icon">
                <div class="icon">
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.95522 12.7451L8.40339 6.31102C8.50528 6.19544 8.55922 6.08536 8.55922 5.95877C8.55922 5.74962 8.37941 5.59 8.12768 5.59H4.74131L6.52739 1.30793C6.76714 0.741029 6.10784 0.432808 5.71826 0.906147L0.270091 7.33475C0.1682 7.45584 0.114258 7.56592 0.114258 7.68701C0.114258 7.90166 0.294065 8.06128 0.545796 8.06128H3.93217L2.14608 12.3378C1.90634 12.9047 2.56563 13.213 2.95522 12.7451ZM5.31669 7.24119H1.61265L4.99304 3.11873L3.35679 6.41009H7.05483L3.67445 10.5325L5.31669 7.24119Z"
                      fill="#F5BCC5"
                    />
                  </svg>
                </div>
                <div class="metric">
                  {{ 'challenges.intensity' | translate }}
                  {{ workout.cls.intensityLevel }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-tabs-item>
    </app-tabs>
  </div>
  }
</app-card>
